<template<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form
        class="clearfix"
        ref="dialogFormRef"
        :model="dialogForm"
        :disabled="true"
        label-width="136px"
      >
        <el-form-item class="half" label="登录用户名" prop="loginUserName">
          <el-input
            v-model="dialogForm.loginUserName"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录IP地址" prop="loginIp">
          <el-input
            v-model="dialogForm.loginIp"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="接口请求地址" prop="apiUrl">
          <el-input
            v-model="dialogForm.apiUrl"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="接口请求状态" prop="status">
          <el-select-dict
            dictType="SUCCESS_FAIL"
            v-model="dialogForm.status"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="接口提示信息" prop="loginMsg">
          <el-input
            v-model="dialogForm.loginMsg"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录日期" prop="loginTime">
          <el-date-picker
            v-model="dialogForm.loginTime"
            type="datetime"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="half" label="接口响应时长(ms)" prop="responseTime">
          <el-input
            v-model="dialogForm.responseTime"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录地址(国家)" prop="loginLocationCountry">
          <el-input
            v-model="dialogForm.loginLocationCountry"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录地址(城市)" prop="loginLocationCity">
          <el-input
            v-model="dialogForm.loginLocationCity"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录地址(区域)" prop="loginLocationRegion">
          <el-input
            v-model="dialogForm.loginLocationRegion"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录地址(经度)" prop="loginLocationLatitude">
          <el-input
            v-model="dialogForm.loginLocationLatitude"
            clearable
          />
        </el-form-item>
        <el-form-item class="half" label="登录地址(纬度)" prop="loginLocationLongitude">
          <el-input
            v-model="dialogForm.loginLocationLongitude"
            clearable
          />
        </el-form-item>
        <el-form-item class="all" label="登录设备信息" prop="browser">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            v-model="dialogForm.browser"
            clearable
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">关 闭</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "loginLogDialog",
  props: {
    // 配置数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialogForm: {
        loginUserName: "", // 登录用户名
        loginIp: "", // 登录IP地址
        apiUrl: "", // 接口请求地址
        status: "", // 请求状态
        loginMsg: "", // 请求提示语
        loginTime: "", // 登录时间
        responseTime: "", // 接口响应时间
        loginLocationCountry: "", // 登录地址(国家)
        loginLocationCity: "", // 登录地址(城市)
        loginLocationRegion: "", // 登录地址(区域)
        loginLocationLatitude: "", // 登录地址(经度)
        loginLocationLongitude: "", // 登录地址(纬度)
        browser: "" // 登录设备信息
      }, // 弹框表单
    }
  },
  watch: {
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
  }
}
</script>
